var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 text-center mt-5"},[_c('p',{staticClass:"text-center"},[_c('router-link',{attrs:{"to":{name: 'signup.phone'}}},[_vm._v("Signup / Login")])],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }